import { SET_AVOID_AREA_DRAWING, CANCEL_AVOID_AREA_DRAWING } from 'actions';

export const defaultAvoidAreaDrawingState = { active: false, tool: 'bbox', shape: null };

export default (state = defaultAvoidAreaDrawingState, { payload = {}, type }) => {
  switch (type) {
    case SET_AVOID_AREA_DRAWING:
      return { ...state, ...payload };
    case CANCEL_AVOID_AREA_DRAWING:
      return defaultAvoidAreaDrawingState;
    default:
      return state;
  }
};
